export function createContainer(containerId: string): Element {
    const container = document.createElement('div');

    container.setAttribute('id', containerId);
    document && document.body.prepend(container);

    return container;
}
